import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Slide from "@mui/material/Slide";
import warningAudio from "../../assets/audio/warning.mp3";
import { useEffect } from "react";
const SlideTransition = (props) => {
  return <Slide {...props} direction="left" />;
};
const Toast = ({
  anchorOrigin = { vertical: "top", horizontal: "right" },
  open = false,
  autoHideDuration = 5000,
  onClose = () => {},
  toastKey,
  children,
  playSound = false,
  audioFile = warningAudio,
}) => {
  useEffect(() => {
    if (playSound && open) {
      const audio = new Audio(audioFile);
      audio.play();
    }
  }, [playSound, open, audioFile]);
  return (
    <Snackbar
      anchorOrigin={anchorOrigin}
      open={open}
      onClose={onClose}
      autoHideDuration={autoHideDuration}
      TransitionComponent={SlideTransition}
      ClickAwayListenerProps={{
        touchEvent: false,
        mouseEvent: false,
      }}
      disableWindowBlurListener={true}
      key={toastKey}
    >
      {children}
    </Snackbar>
  );
};

export default Toast;
